var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCongratulations(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 55,
    viewBox: "0 0 56 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.21 30.44C29.21 30.44 33.5 24.54 40.05 28.24C47.07 32.21 50.86 31.09 52.29 24.54",
    stroke: "#EB731A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0197 6.27002C39.0197 6.27002 31.2397 8.12002 30.8397 15.63C30.6197 19.82 29.5397 23.85 25.4897 26.37",
    stroke: "#EB731A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3198 17.33C45.4298 14.93 48.1898 14.27 49.6098 14.14C52.2698 13.89 54.6898 12.69 54.4798 9.77002",
    stroke: "#010101",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.48 1.06982C22.48 1.06982 26.76 2.50982 23.52 6.47982C19.78 11.0598 22.97 13.8998 22.97 13.8998",
    stroke: "#010101",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0201 21.0098C39.6883 21.0098 40.2301 20.4681 40.2301 19.7998C40.2301 19.1316 39.6883 18.5898 39.0201 18.5898C38.3518 18.5898 37.8101 19.1316 37.8101 19.7998C37.8101 20.4681 38.3518 21.0098 39.0201 21.0098Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.19 7.48006C14.8582 7.48006 15.4 6.93832 15.4 6.27006C15.4 5.60179 14.8582 5.06006 14.19 5.06006C13.5217 5.06006 12.98 5.60179 12.98 6.27006C12.98 6.93832 13.5217 7.48006 14.19 7.48006Z",
    fill: "#EB731A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5498 39.5597C45.2181 39.5597 45.7598 39.0179 45.7598 38.3496C45.7598 37.6814 45.2181 37.1396 44.5498 37.1396C43.8816 37.1396 43.3398 37.6814 43.3398 38.3496C43.3398 39.0179 43.8816 39.5597 44.5498 39.5597Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9102 2.54988C50.5785 2.54988 51.1202 2.00815 51.1202 1.33988C51.1202 0.671618 50.5785 0.129883 49.9102 0.129883C49.2419 0.129883 48.7002 0.671618 48.7002 1.33988C48.7002 2.00815 49.2419 2.54988 49.9102 2.54988Z",
    fill: "#EB731A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8798 37.83L1.50977 53.87L17.5398 19.5L35.8798 37.83Z",
    stroke: "#010101",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 40.4897V50.6597",
    stroke: "#010101",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1899 26.3701V47.4801",
    stroke: "#010101",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6299 22.5801V44.9501",
    stroke: "#010101",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0596 29.02V41.95",
    stroke: "#010101",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCongratulations);
export default __webpack_public_path__ + "static/media/congratulations.a5fded11a728714b37c56957da543a8d.svg";
export { ForwardRef as ReactComponent };